// extracted by mini-css-extract-plugin
export default {"switcherContainer":"Switcher_switcherContainer__Lijh3","switcherOption":"Switcher_switcherOption__rDjw4","selectedSwitcherOption":"Switcher_selectedSwitcherOption__dnntj"};